module.exports = __webpack_public_path__ + "img/_temp_dashboard.306b3ec2.svg";